export default __webpack_public_path__ + "static/media/istockphoto-1243522179-612x612.72526b68.jpg";